<template>
    <div id="follow">
        <p>作品为正版授权小说</p>
        <p>通过服务号为您提供更多的阅读服务</p>
        <p>请关注作者授权的公众号继续阅读</p>
        <img :src="'http://open.weixin.qq.com/qr/code?username=' + cover" alt="" v-if="cover">
        <p>长按上图识别二维码关注</p>
        <p><span>关注后，点击阅读历史即可继续阅读</span></p>
    </div>
</template>

<script>
    export default {
        name: "Follow",
        data (){
            return {
                cover : ''
            }
        },
        methods:{
            setWechatFollow(){
                this.axios.post("/api/chapter/setWechatFollow",{
                    bookid : this.$route.params.wid,
                    chapterid : this.$route.params.cid
                }).then(r => {
                    let data = r.data;
                    if(data.code){
                        this.cover = data.data.cover
                    }else{
                        this.$message.error(data.msg);
                    }
                });
            }
        },
        created(){
            this.setWechatFollow();
        }
    }
</script>

<style lang="less">
    #follow{text-align: center;
        p{font-size: 32px;color: orangered;}
        img{width: 60%;}
    }

</style>
